import { defineStore } from 'pinia'

// Define the state interface
interface AuthState {
  isAuthenticated: boolean
}

export const useAdminAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    isAuthenticated: false
  }),
  actions: {
    logIn() {
      this.isAuthenticated = true
    },
    logOut() {
      this.isAuthenticated = false
    }
  },
  getters: {
    isLoggedIn: (state: AuthState) => state.isAuthenticated
  }
})
